import "swiper/css";
import "swiper/css/pagination";
import { Pagination } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import Common_bill_payments from "../../common_components/common_cards/common-bill-payments/Common_bill_payments";
import Common_section_heading from "../../common_components/common_heading/common_section_heading/Common_section_heading";
import "./Bill_payments.css";

const Bill_payments = ({ services = [], sectionTitle, sectionSubtitle }) => {


  return (
    <section className="payment_section section_margin">
      <div className="container ">
        {/* Heading */}

        <Common_section_heading title={sectionTitle} subTitle={sectionSubtitle} />

        {/* SWIPER */}
        <div className="service_cards_swiper ">
          <Swiper
            modules={[Pagination]}
            spaceBetween={30}
            slidesPerView={5}
            pagination={{ clickable: true }}
            breakpoints={{
              320: { slidesPerView: 1.5 },
              485: { slidesPerView: 2.2 },
              574: { slidesPerView: 2.5 },
              767: { slidesPerView: 3.5 },
              990: { slidesPerView: 3.5 },
              1023: { slidesPerView: 3.5 },
              1199: { slidesPerView: 4.5 },
              1299: { slidesPerView: 5 },
            }}
            className="mySwiper_common_swiper"
          >
            {services.map((service) => (
              <SwiperSlide key={service.id}>
                <Common_bill_payments img={service.img}
                  title={service.title}
                  baseLink={service.baseLink} />
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
    </section>
  );
};

export default Bill_payments;